var _rect, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#007AFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.16567,
    cy: 4.16567,
    r: 4.16567,
    transform: "matrix(1 0 0 -1 10.86 19.3314)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.357 29.7455C23.7404 29.7455 24.054 29.4342 24.0245 29.0519C23.9515 28.1042 23.7291 27.1724 23.3642 26.2916C22.9106 25.1965 22.2458 24.2016 21.4077 23.3635C20.5696 22.5253 19.5746 21.8605 18.4796 21.4069C17.3845 20.9534 16.2109 20.7199 15.0256 20.7199C13.8404 20.7199 12.6667 20.9534 11.5717 21.4069C10.4766 21.8605 9.48165 22.5253 8.64354 23.3635C7.80544 24.2016 7.14061 25.1965 6.68703 26.2916C6.32216 27.1724 6.09974 28.1042 6.02669 29.0519C5.99722 29.4342 6.31084 29.7455 6.69428 29.7455H23.357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.8283L27.8095 22L34 16",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralFriends);
export default __webpack_public_path__ + "static/media/referral-friends.23a0e13d472bcbba57796e9171c6a2c6.svg";
export { ForwardRef as ReactComponent };